<template>
    <vehicle-query />
</template>

<script>
    import VehicleQuery from './components/VehicleQuery'
    export default { name: 'pageAssetVehicleInsurance', components: { VehicleQuery } }
</script>
